import axios from "axios";
import { Cookies } from "react-cookie";
import { AddToastNotification } from "../ToastNotification/ToastNotificationManager";

let api_url = window.api_url + "api/AdminPanel/Auth/";

const cookies = new Cookies();

const LoginFirstStep = (loginOrEmail, password, onSuccess, onFail) =>
{
    let loginData = {
        emailOrLogin: loginOrEmail,
        password: password
    };

    axios.post(api_url + "Login", loginData)
    .then((res) => 
    {
        if(res.data != 0)
            onSuccess(res.data);
        else
            onFail("Wrong password or login");
    })
    .catch((reason) => { onFail(reason.message)});
}

const LoginSecondStep = (code, codeId, onSuccess, onFail) =>
    {
        let loginData = {
            CodeId: codeId,
            Code: code
        };
    
        axios.post(api_url + "Login2FA", loginData)
        .then((res) => 
        {   
            if(!res.data.error)
            {
                cookies.set("jwt", res.data.jwt, { maxAge: 600, path: '/', secure: true, sameSite: "strict" });
    
                cookies.set("refreshToken", res.data.refreshToken, {maxAge: 2147483647, path: '/', secure: true, sameSite: "strict"});
                onSuccess();
            }else{
                onFail(res.data.error)
            }
        })
        .catch((reason) => { onFail(reason.message)});
    }

const RefreshToken = (onSuccess, OnFail) =>
{
    let token = cookies.get("refreshToken");
    
    if(token)
    {      
        axios.post(api_url + "RefreshJWT", {refreshToken: token})
        .then((res) => 
        {
            cookies.set("jwt", res.data, {maxAge: 600, path: '/', secure: true, sameSite: "strict"});

            //Remove tokens on error
            if(!res.data) {
                cookies.remove("refreshToken");
                cookies.remove("jwt");
                OnFail();
            }else
            {
                onSuccess()
            }

        }).catch((error) => 
        {
            console.error(error);
            AddToastNotification(error.message + ` [${error.config.url}]`, 0);
            OnFail();
        });
    }else {
        cookies.remove("refreshToken");
        cookies.remove("jwt");
        OnFail();
    }
}

const ChangePassword = (data, navigate, setChangePasswordWindow) =>
{
    axios.post(api_url + "ChangePassword", data, {headers: {Authorization: "Bearer " + cookies.get("jwt")}})
    .then((res) => 
    {
        AddToastNotification("Password changed successfully!", 1);

        cookies.remove("refreshToken");
        cookies.remove("jwt");

        setChangePasswordWindow(false);
        navigate("/")
    }).catch((error) => 
    {
        AddToastNotification(error.message, 0);
        console.error(error);
    });
}

const GetSessions = (setSessions) =>
{
    axios.get(api_url + "GetSessions", {headers: {Authorization: "Bearer " + cookies.get("jwt")}})
    .then((res) => 
    {
        setSessions(res.data);
    }).catch((err) => 
    {
        console.error(err);
    });
}

const Logout = (id, onSuccess) => 
{
    axios.post(api_url + "Logout/"+id, null, {headers: {Authorization: "Bearer " + cookies.get("jwt")}})
    .then((res) => 
    {
        onSuccess();
    }).catch((error) => 
    {
        console.error(error);
        AddToastNotification(error.message, 0);
    });
}
    


export { RefreshToken, ChangePassword, LoginFirstStep, LoginSecondStep, GetSessions, Logout };